import { handleStatus500 } from 'api/Utility/HandleStatus500'
import AxiosInitializer from 'api/Utility/AxiosInitializer'
import getToken from 'lib/authentication/GetToken'
import apiWrapper from 'api/Utility/ApiWrapper'

type AddNoteRequestPayload = {
  participantId: string
  payload: {
    data: {
      attributes: {
        note: {
          content: string
          project_id?: string
        }
      }
    }
  }
}

const axiosRequest = (extraParams: any = {}) => {
  const params = {
    token: getToken(),
    ...extraParams,
  }

  return AxiosInitializer({
    ...params,
  })
}

const addNoteEndPoints = {
  addNote: (params: AddNoteRequestPayload) => {
    const { participantId, payload } = params

    const URL = `/users/${participantId}/admin_notes`

    return axiosRequest().post(URL, payload)
  },
}

const addNoteAPI = {
  addNote: (params: AddNoteRequestPayload) =>
    apiWrapper({
      endPoint: addNoteEndPoints.addNote,
      params,
      errorFailureAction: handleStatus500,
    }),
}

export default addNoteAPI
